import SettingsIcon from '@mui/icons-material/Settings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';

export const enum AccessRole {
  Merchant = 'ROLE_MERCHANT',
  Service = 'ROLE_SERVICE',
}

export const ACCESS_TITLES = {
  [AccessRole.Merchant]: 'Мерчант',
  [AccessRole.Service]: 'Сервис',
};

export const ACCESS_SELECT_ITEMS = [
  { id: AccessRole.Merchant, label: 'Мерчант' },
  { id: AccessRole.Service, label: 'Сервис' },
];

export const ACCESS_ROLES_ICONS: { [key in AccessRole]?: React.ReactElement } = {
  [AccessRole.Merchant]: <SupervisedUserCircleIcon color="secondary" />,
  [AccessRole.Service]: <SettingsIcon color="secondary" />,
};
